var canvas, canvas2, text, fontSize, fontFamily, fSize, activeCOLOR, newText, zoom, cWidth = 1000, cHeight = 1167,
    halfWidth = cWidth / 2, halfHeight = cHeight / 2,
    obj, array = [], get_data, sizeCrop,
    scale_factor, newheight, leftOb, imageUrl,
    placeholderimg1,img,designResiz,
    leftMarker, rightMarker, vLine;

var loader = jQuery('#customLoader'),
    cropper = "", canvas, boxWidth, boxLeft, boxTop,
    croppedSize, orientations, aspectRatio, reCroper,
    c1img1;

var outLine,sizeBmW = 715, sizeBmH = 450,
    sizeB1W = 900, sizeB1H = 900,
    sizeB2W = 250, sizeB2H = 385;

imageUrl = document.getElementById('imageContainer').getAttribute('data-image-url');


var shirtColor = jQuery('input[name="Color"]:checked').val();
url = jQuery('#cricket_shirt_frontside a[data-title="'+shirtColor+'"] img').attr('data-src');

function updatefrontShirtImage(){
  var shirtColor = $('input[name="Color"]:checked').val();
  var url = $('#cricket_shirt_frontside a[data-title="' + shirtColor + '"] img').attr('data-src');
  if (window['frontShirt']){
    canvas2.remove(window['frontShirt']);
  }
  if(url){
    fabric.Image.fromURL(url, function(img){
      window['frontShirt'] = img;
      window['frontShirt'].set({
        id: 'frontShirt',
        left: halfWidth,
        top: 500
      });
      window['frontShirt'].scaleToWidth(sizeB1W);
      canvas2.add(window['frontShirt']);
      window['frontShirt'].sendToBack();
      canvas2.renderAll();
    });
  }
}

$(document).on('change', 'input[name="Color"]', function () {
    var shirtColor = $(this).val();
    setTimeout(function () {
        updatefrontShirtImage(shirtColor);
    }, 100); 
});

updatefrontShirtImage();


let frameImg = document.querySelector("#shirt_design");
let simpleImage = new fabric.Image(frameImg, {
  left: 250,   
  top: 260,
  scaleX: 0.5,
  scaleY: 0.5,
  selectable: false
});
window['canvas2'] = new fabric.Canvas('canvas2', {
  width: cWidth,
  height: cHeight
});

window['canvas2'].add(simpleImage);
simpleImage.bringToFront();
addModify(window['canvas2']);



window['placeholderimg1'] = new fabric.Rect({
  left: 465,
  top: 516,
  width: sizeB2W,
  height: sizeB2H,
  fill: 'rgba(0,0,0,0.1)'
});

window['placeholderimg1'].sendToBack();
window['canvas2'].add(window['placeholderimg1']);

document.getElementById('image_upload_first').addEventListener('change',function(e){
  canvas = window['canvas2'];
  available_height = sizeB2H;
  img = window['placeholderimg1'];
  sizeCrop = '0.65';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  input = jQuery(this);
  readURL2(e.target);
});


window['text1Page'] = new fabric.Text('AHTISHAM',{
  left: 605,
  top: 687,
  fontSize: 19,
  fontFamily: 'Times New Roman',
  fill: '#fff',
  textAlign: 'left',
  originX: 'left',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});

var fontName = window['text1Page'].fontFamily;
jQuery('.choose_font').val("'" + fontName + "'").trigger('change');

// Add to canvas
window['canvas2'].add(window['text1Page']);

// Clear text on input focus if default
document.getElementById('text_1').addEventListener('focus', function () {
  if (window['text1Page'].text === 'AHTISHAM') {
    window['text1Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});

// Fit text within a specific width
function fitTextToWidth(textObj, maxWidth) {
  let fontSize = 19; // Start from larger size
  textObj.set({ fontSize });

  // Repeatedly shrink font until it fits
  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

// Update text live and auto-fit width
document.getElementById('text_1').addEventListener('input', function (e) {
  const newText = e.target.value;
  window['text1Page'].set('text', newText);
  fitTextToWidth(window['text1Page'], 112); // ← adjust width as needed
  window['text1Page'].bringToFront();
  window['canvas2'].renderAll();
});


function canvasMakeImg(canvas,zoom){
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function canvasBlock(canvas){
  zoom = jQuery('.product__media-outer').width();
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function setZoomMask(canvas,newZoomLevel){
  canvas.setZoom(newZoomLevel);
  canvas.setDimensions({
    width:  cWidth * newZoomLevel,
    height:  cHeight * newZoomLevel
  });
  canvas.renderAll();
}

function addModify(canvas){
  fabric.Object.prototype.transparentCorners = false;
  fabric.textureSize = 75497472;

  canvas.renderOnAddRemove = false;
  canvas.on('selection:cleared', function(e){
    object = e.target;
  });

  canvas.on('object:removed',function(e){
    object = e.target;
  });

  canvas.on('object:added', function(e){
    object = e.target;
    addControls(object);
    canvas.renderAll();
  });
  
  canvas.on('object:modified', function(e){
    object = e.target;
    canvas.renderAll();
  });
  
  canvas.on('selection:created', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('selection:updated', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('object:scaling', function(e){
    canvas.renderAll();
  });

  jQuery(window).on('load',function(){
    canvasBlock(canvas);
  });

  jQuery(window).on('resize',function(){
    canvasBlock(canvas);
  });
}

function addControls(object){
  var iconTL = document.createElement("img"),
      iconBR = document.createElement("img");
  
  iconTL.src = trashIcon;
  iconBR.src = resizeIcon;
  
  object.set({
    selectable:false,
    originX:"center",
    originY:"center",
    transparentCorners: false,
    borderColor: '#ddd',
    borderDashArray: [6,2],
    cornerStyle: 'circle',
    cornerColor: '#fff',
    objectCaching: false,
    _controlsVisibility: {
      tr: false,
      tl: true,
      bl: false,
      br: true,
      mb: false,
      ml: false,
      mr: false,
      mt: false,
      mtr: false
    }
  });
  
  iconTL.onload = function() {
    fabric.Object.prototype.controls.tl = new fabric.Control({
      x: -0.5,
      y: -0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "pointer",
      mouseUpHandler: deleteHandler,
      render: renderIcon(iconTL),
      withConnection: true,
      cornerSize: 18,
    });
  };
  iconBR.onload = function() {
    fabric.Object.prototype.controls.br = new fabric.Control({
      x: 0.5,
      y: 0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "se-resize",
      mouseUpHandler:fabric.controlsUtils.scalingEqually,
      render: renderIcon(iconBR),
      withConnection: true,
      cornerSize: 18,
    });
  }
}

function renderIcon(icon) {
  return function (ctx, left, top, styleOverride, fabricObject) {
    const size = this.cornerSize;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(icon, -size / 2, -size / 2, size, size);
    ctx.restore();
  };
}

function deleteHandler(eventData,transform){
  var target = transform.target;
  activeOb = canvas.getActiveObject();
  canvas.remove(activeOb);
  canvas.renderAll();
}

initCropper();

function readURL2(input){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  if(cropper == ""){
  }else {
    cropper.destroy();
  }
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function (e) {
      jQuery('#blah').attr('src', e.target.result);
      reCroper.attr('data-img',e.target.result);
    };
    reader.readAsDataURL(input.files[0]);
    setTimeout(initCropper, 2500);
  }
}

function addImage(e,placeholderimg,canvas){
  var file = e.target.files[0];
  var reader = new FileReader();
  reader.onload = function(event){
    var imgObj = new Image();
    imgObj.src = event.target.result;
    imgObj.onload = function(){
      var img = new fabric.Image(imgObj);
      img.set({
        left: placeholderimg.left,
        top: placeholderimg.top,
        selectable:true,
        scaleX: placeholderimg.width / img.width,
        scaleY: placeholderimg.height / img.height,
      });
      canvas.add(img);
    };
  };
  reader.readAsDataURL(file);
}

function addCroppedImg(imgurl){
  canvas.remove(img).renderAll();
  fabric.Image.fromURL(imgurl, function(newImg){
    newImg.set({
      left: img.left,
      top: img.top,
      selectable: img.selectable
    });
    newImg.scaleToHeight(available_height);
    canvas.add(newImg).renderAll();
    img = newImg;
    simpleImage.bringToFront();
    window['text1Page'].bringToFront();
    canvas.renderAll();
  });
}

function initCropper(){
  var image = document.getElementById('blah');
  cropper = new Cropper(image, {
    viewMode: 1,
    dragMode: 'move',
    aspectRatio: sizeCrop,
    restore: false,
    guides: false,
    center: true,
    highlight: true,
    cropBoxMovable: true,
    cropBoxResizable: true,
    toggleDragModeOnDblclick: false,
    data:{}
  });
  jQuery('.popupImg').show();
  jQuery('#tadaWidget').addClass('hidden');
  loader.addClass('hidden');
}

document.getElementById('crop_button').addEventListener('click', function(){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  var imgurl =  cropper.getCroppedCanvas().toDataURL();
  input.attr('data-cropped',imgurl);
  addCroppedImg(imgurl);
  setTimeout(function(){
    reCroper.parent().removeClass('hidden');
    jQuery('.popupImg').hide();
    loader.addClass('hidden');
    jQuery('#tadaWidget').removeClass('hidden');
  },500);
});


document.getElementById('zoom_out').addEventListener('click', function(){
  cropper.zoom(-0.1);
});

document.getElementById('zoom_in').addEventListener('click', function(){
  cropper.zoom(0.1);
});

document.getElementById('reset_button').addEventListener('click', function(){
  cropper.reset();
});

document.getElementById('cancelCropper').addEventListener('click', function(){
  jQuery('.popupImg').hide();
  jQuery('#tadaWidget').removeClass('hidden');
});

jQuery(document).on('click','.btnReCrop', function(){
  loader.removeClass('hidden');
  imgurl = jQuery(this).attr('data-img');
  sizeCrop = jQuery(this).attr('data-ratio');
  img = window[jQuery(this).attr('data-obj')];
  canvas = window['canvas'];
  available_height = jQuery(this).attr('data-height');
  input = jQuery(this).parent().parent().find('input[type="file"]');
  jQuery('#tadaWidget').addClass('hidden');
  setTimeout(function(){
    cropper.destroy();
    jQuery('#blah').attr('src',imgurl);
    initCropper();
    jQuery('.popupImg').show();
    loader.addClass('hidden');
  },150);
});

jQuery('.customColors').each(function(){
  colorBox = jQuery(this).attr('id');
  loadColorPicker(colorBox);
});

jQuery(document).on('change','.fontFamily',function(){
  var fontID = jQuery(this).attr('data-canvas');
  fontSize = '';
  activeCOLOR = '';
  fontFamily = jQuery(this).val();
  canvas = window[fontID];
  updateFont(window['text1Page'],fontFamily,fontSize,activeCOLOR);
  fitTextToWidth(window['text1Page'], 185);
});



function updateFont(activeOb,family,size,fill){
  if(activeOb){
    if(family == ''){
      family = activeOb.fontFamily;
    }
    if(size == ''){
      size = activeOb.fontSize;
    }
    if(fill == ''){
      fill = activeOb.fill;
    }
    sCAle = activeOb.scaleX;
    activeOb.set('fontSize',size);
    activeOb.set('fontFamily',family);
    activeOb.set('fill',fill);
    activeOb.scaleX = .5;
    activeOb.setCoords();
    canvas.renderAll();
    activeOb.scaleX = sCAle;
    activeOb.setCoords();
    canvas.renderAll();
  }
}

jQuery(document).on('click','.dropper-eyedrop',function(){
  const eyeDropper = new EyeDropper();
  eyeDropper.open().then(result => {
    jQuery(this).parent().parent().parent().colorpicker('setValue', result.sRGBHex);
  }).catch(e => {
    console.error(e);
  });
});


async function handleUpload(fileInputs,timeID){
  const temp_images = [];

  temp_images.push(jQuery('#crop_button').attr('data-cropped'));
  
  for (let input of fileInputs){
    const file = input.files[0]; // Only first file per input
    if(file){
      const base64 = await toBase64(file); // ✅ now safely inside async
      temp_images.push(base64);
    }
  }
  if(temp_images.length === 0){
    alert("Please select at least one image.");
    return;
  }
  const payload = {
    timeId: timeID,
    temp_images: temp_images
  };
  console.log(payload);
  try {
    const response = await fetch('//technology-architects.com/tasweer-modules/upload_client_img.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });
    
    const result = await response.json();
    console.log("Upload result:", result);
    var int = 1;
    result.uploaded_images.forEach(img => {
      if(jQuery('#image'+int).length < 1){
        jQuery('#preview').append('<input type="hidden" id="image'+int+'" name="properties[User Upload '+int+']">');
      }
      if (img.status === "success") {
        jQuery('#image'+int).val(img.image_url);
        int += 1;
      } else {
        console.warn("Upload failed:", img.error);
      }
    });
    jQuery('.product-form__buttons .product-form__submit').trigger('click');
    loader.addClass('hidden');
  } catch (error) {
    console.error("Upload error:", error);
    alert("Upload failed.");
  }
}

// ✅ Convert a file to base64 string
function toBase64(file){
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}


/* fetch Call */
var size,thumbnail;
var loadedObject,enterName,chooseSize,chooseFont,additionalInfo,wMark,svgMrk;
let pdfData = {};
jQuery(document).on('click','#download',function(){
  loader.removeClass('hidden');
  setTimeout(function(){
    resizeObjects(window['canvas2']);
    const id = ['canvas2'];
    const canvas = window['canvas2'];
    size = 463;
    loadMark(id,canvas,size);
    size = 4000;
    removeMark(canvas,size);
    // hideExtras(canvas);
    window['frontShirt'].set('opacity',0);
    window['canvas2'] = canvas.toDataURL('image/png');
    enterName = jQuery('.enter_name input').val();
    chooseSize = jQuery('.choosed-size input:checked').val();
    chooseFont = jQuery('.choose_font option:selected').val();
    additionalInfo = jQuery('.tShirtImg textarea').val();
    // showExtras(canvas);
    canvasBlock(canvas);
    console.log(window['canvas2']);
    fetch('//technology-architects.com/tasweer-modules/save_order.php',{
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body:  JSON.stringify({
        temp_image: window['canvas2t'],
        original_image: window['canvas2']
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      var previewId = data[0],
          extraImg1 = data[1];
      jQuery('#previewImg').val(previewId);
      jQuery('#preExtraImg').val(extraImg1);
      jQuery('#enterName').val(enterName);
      jQuery('#chooseSize').val(chooseSize);
      jQuery('#chooseFont').val(chooseFont);
      jQuery('#addInfo').val(additionalInfo);
      console.log('Server response:', data);
      const fileInputs = document.querySelectorAll('.upload_image input[type="file"]');
      handleUpload(fileInputs,previewId);
    })
    .catch(error => console.error('Error uploading images:', error));
  },100);
});


function resizeObjects(canvas){
  window['text1Page'].setCoords();
  simpleImage.setCoords();
  img.setCoords();
  canvas.renderAll();
  var designResiz = new fabric.Group([window['text1Page'],simpleImage,img]);
  designResiz.set({
    left: 500,
    top: 580,
    originX: 'center',
    originY: 'center'
  });
  designResiz.scaleToWidth('1350');
  designResiz.setCoords();
  window['frontShirt'].set('opacity',0);
  canvas.renderAll();
}


function loadMark(id,canvas,size){
  wMark = document.getElementById('wm_collage');
  svgMrk = wMark.innerHTML;
  fabric.loadSVGFromString(svgMrk, function(objects,options){
    loadedObject = fabric.util.groupSVGElements(objects, options);
    loadedObject.scaleToWidth(cWidth);
    loadedObject.set({
      left: cWidth / 2,
      top: cHeight / 2,
      originX: 'center',
      originY: 'center',
      objectCaching: false,
      selectable: false
    });
    // canvas.add(loadedObject);
    // loadedObject.bringToFront();
    // loadedObject.setCoords();
    window['frontShirt'].set('opacity',0);
    canvas.renderAll();
  });
  canvasMakeImg(canvas,size);
  window[id+'t'] = canvas.toDataURL('image/png');
  console.log(window[id+'t']);
}

function removeMark(canvas,size){
  canvas.remove(loadedObject).renderAll();
  canvasMakeImg(canvas,size);
}